<template functional>
  <label
    :class="[$style.formLabel, props.small && $style.small]"
    :for="props.for"
  >
    <slot />
  </label>
</template>

<style lang="scss" module>

.formLabel {
  text-align: left;
  font-size: 1.6rem;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.2;
  letter-spacing: 0.6px;
  display: block;
  width: 100%;
  margin: 20px auto 10px;
  color: $color-text;

  &.small {
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 1.4;
    color: $color-text--lighter;
  }

  a {
    color: #e73273;
    text-decoration: underline;
    font-weight: normal;
    cursor: pointer;
  }
}

</style>

<script>

export default {
  props: {
    for: {
      type: String,
      required: false,
      default: '',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
